import React from "react";
import { docsResources } from "./.resources";
import { useResources } from "../../hooks/useResources";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
} from "@mui/x-data-grid";
import { useDataGridStyles } from "../../hooks/useDataGridStyles";
import { Link } from "@mui/material";

export interface IMyDocumentRow {
  productId: string;
  productName: string;
  documentName: string;
  onOpen: (productId: string | undefined) => void;
}

export interface IMyDocumentsGridProps {
  documents: IMyDocumentRow[];
}

const MyDocumentsGrid: React.FC<IMyDocumentsGridProps> = ({
  documents,
}) => {
  // Language sync is handled globally in App.tsx
  const res = useResources(docsResources);
  const { styles: gridStyles } = useDataGridStyles({
    variant: "common",
    type: "purchases",
  });



  const columns: GridColDef[] = [
    {
      field: "productName",
      headerName: res.product,
      width: 300,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row;
        return (
          <Link
            href="#"
            color={row.isCanceled === true ? "secondary" : "primary"}
            onClick={() => row.onOpen(row.productId)}
            variant="inherit"
          >
            <div>{row.productName}</div>
          </Link>
        );
      },
    },
    { field: "documentName", headerName: res.document, width: 400 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <DataGrid
        rows={documents}
        columns={columns}
        sx={gridStyles}
        getRowId={(row) => row.productId || Math.random()}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 },
          },
          sorting: {
            sortModel: [{ field: "productName", sort: "desc" }],
          },
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        checkboxSelection={false}
        disableRowSelectionOnClick
      />
    </div>
  );
};

export default MyDocumentsGrid;
